import { render, staticRenderFns } from "./UserUpcomingReservations.vue?vue&type=template&id=12594002&scoped=true"
import script from "./UserUpcomingReservations.vue?vue&type=script&lang=js"
export * from "./UserUpcomingReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12594002",
  null
  
)

export default component.exports